import { CSSProperties, PropsWithChildren, FunctionComponent } from 'react';
import 'src/styles/components/common/Spinner.scss';
import { projectColors } from 'src/styles/project-styles';

export type SpinnerType = 'primary' | 'warning' | 'white' | 'current';

type Props = PropsWithChildren & {
  size?: 'xxs' | 'xs' | 'small' | 'medium' | 'large';
  sizePx?: number;
  type?: SpinnerType;
  className?: string;
  'data-testid'?: string;
};

const sizeToPixel = {
  xxs: 20,
  xs: 24,
  small: 34,
  medium: 44,
  large: 60,
};

const lineForSize = (diameter: number) => (diameter <= 24 ? 2 : 4);

const Spinner: FunctionComponent<Props> = ({
  size = 'medium',
  sizePx,
  type = 'primary',
  className,
  'data-testid': dataTestId,
}) => {
  const colorType = {
    primary: projectColors.primary.darkest,
    white: projectColors.white,
    warning: projectColors.orange,
    current: 'currentColor',
  };

  const diameter = sizePx ?? sizeToPixel[size];
  const spinnerColor = colorType[type];

  const styleVariables: CSSProperties & Record<`--${string}`, string> = {
    '--spinner-size': `${diameter}px`,
    '--spinner-line': `${lineForSize(diameter)}px`,
    '--spinner-color': spinnerColor,
  };

  return (
    <div
      className={`flex justify-center items-center ${className}`}
      style={styleVariables}
      data-testid={dataTestId}
    >
      <div className="spinner-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Spinner;
